import React from "react";
import Layout from "../../components/Layout";

const PaymentErrorPage = () => {
	return (
		<Layout>
		<div className="min-h-screen bg-[#f5f3ee] flex items-center justify-center px-4">
		<div className="bg-white shadow-2xl rounded-2xl max-w-xl w-full p-8 text-center">
		
		<div className="flex flex-col items-center">
		<svg
		className="w-16 h-16 text-red-500 mb-4"
		fill="none"
		stroke="currentColor"
		viewBox="0 0 24 24"
		>
		<path
		strokeLinecap="round"
		strokeLinejoin="round"
		strokeWidth={2}
		d="M6 18L18 6M6 6l12 12"
		/>
		</svg>
		
		<h2 className="text-2xl font-bold text-gray-900 mb-2">Ödəniş baş tutmadı</h2>
		<p className="text-gray-700 text-sm sm:text-base leading-relaxed">
		Təəssüf ki, ödəniş zamanı bir xəta baş verdi. <br />
		Lütfən bağlantınızı yoxlayın və ya bir neçə dəqiqə sonra yenidən cəhd edin.
		</p>
		
		<div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
		<a href="/events/6810d0862c4130f769b80d6e" className="bg-black text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition-all">
		Yenidən cəhd et
		</a>
		<a href="/" className="bg-gray-200 text-gray-800 px-6 py-3 rounded-lg font-semibold hover:bg-gray-300 transition-all">
		Ana səhifəyə qayıt
		</a>
		</div>
		</div>
		</div>
		</div>
		</Layout>
	);
};

export default PaymentErrorPage;
